import React, { useState, useRef, useEffect } from "react";
import CompanyLogo from "../../../../assets/img/logos/dicelogoTransparent_01.png";
import background from "../../../../assets/img/logos/Tag_template.jpg";
import QrCodes from "../appComponents/QrCodes";
import BarCode from "../appComponents/BarCode";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const StaffIDCard = (props) => {
  const [itemValues, setItemValues] = useState([]);
  const [itemReferenceNo, setItemReferenceNo] = useState("");
  const QrCodeRef = useRef(null);

  useEffect(() => {
    setItemValues(props.itemValues || []);
    setItemReferenceNo(props.itemReferenceNo || "");
  }, [props.itemValues, props.itemReferenceNo]);

  const styles = {
    background: {
      backgroundImage: `url(${background})`,
      height: "100%",
      width: "96%",
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat",
      display: "block",
      position: "relative",
      zIndex: 0,
    },
    qrCode: {
      marginLeft: "250px",
      paddingTop: "275px",
      position: "absolute",
      zIndex: "10",
    },
    returnInfo: {
      fontSize: "14px",
      padding: "10px 15px",
      textAlign: "center",
    },
    barcodeContainer: {
      paddingTop: "10px",
    },
    qrCodePositioning: {
      paddingLeft: "20%",
    },
  };

  return (
    <>
      <table
        ref={QrCodeRef}
        width="510"
        border="1"
        align="left"
        cellpadding="0"
        cellspacing="0"
        height="367"
      >
        {itemReferenceNo && (
          <div style={styles.qrCode}>
            <QrCodes addrurl={itemReferenceNo} qrcodeSize={"78px"} />
          </div>
        )}
        <tr>
          <td>
            {/* Request QRCODE */}

            {/* End of Request QRCODE */}

            <table width="255" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td align="center" height="10">
                  <table
                    width="100%"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                  >
                    <tr>
                      <td width="20%" align="rigth">
                        &nbsp;
                      </td>
                      <td width="80%" align="center"></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="5"
                  >
                    <tr>
                      <td align="center">
                        <strong style={{ fontSize: "14px", color: "#000" }}>
                          Security Staff Attendance Card
                        </strong>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <table
                    width="100%"
                    border="0"
                    align="center"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td>
                        {itemReferenceNo && (
                          <div style={styles.qrCodePositioning}>
                            <QrCodes
                              addrurl={itemReferenceNo}
                              qrcodeSize={"120px"}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td style={styles.returnInfo}>
                        Please return if found. This property belongs to The
                        Community
                        <br />
                        <em style={{ fontSize: "14px", color: "#FF0000" }}>
                          {" "}
                          Compensation Lay-out, New Kutunku, Gwagwalada, Abuja.
                        </em>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
          <td>
            <table
              width="255"
              border="0"
              cellspacing="0"
              cellpadding="0"
              style={styles.background}
            >
              <tr>
                <td align="center">
                  <table
                    width="100%"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    style={{ marginTop: "4px" }}
                  >
                    <tr>
                      <td width="26%" align="rigth">
                        <img
                          loading="lazy"
                          decoding="async"
                          name=""
                          src={CompanyLogo}
                          width="45"
                          style={{ paddingLeft: "7px" }}
                          alt={CompanyLogo || "Image"}
                        />
                      </td>
                      <td
                        width="74%"
                        align="left"
                        valign="top"
                        style={{
                          fontSize: "13px",
                          color: "#FFF",
                          paddingTop: "15px",
                          paddingLeft: "0px",
                          marginLeft: "0px",
                        }}
                      >
                        <strong
                          style={{
                            paddingLeft: "0px",
                            marginLeft: "-7px",
                          }}
                        >
                          WEBDYNAMO ATTENDANCE
                        </strong>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td
                        width="100%"
                        align="center"
                        style={{
                          fontSize: "9px",
                          color: "#FF0000",
                          padding: "12px 10px 8px 10px",
                        }}
                      >
                        <em>
                          <b>
                            Compensation Lay-out, New Kutunku, Gwagwalada, Abuja
                            FCT
                          </b>
                        </em>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <table
                    width="100%"
                    border="0"
                    align="center"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tr>
                      <td
                        align="center"
                        style={{ padding: "0px 20px 3px 20px" }}
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          name="2"
                          src={
                            BACKEND_URL + itemValues.passport ??
                            BACKEND_URL +
                              "upload/admin_passports/1673523387.jpg"
                          }
                          width="100"
                          height="120"
                          alt={itemValues.passport || "Image"}
                        />
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <strong
                    style={{
                      fontSize: "16px",
                      color: "#000",
                    }}
                  >
                    {itemValues.name}
                  </strong>
                </td>
              </tr>

              <tr>
                <td
                  align="center"
                  style={{
                    fontSize: "12px",
                    color: "#FF0000",
                    paddingBottom: "10px",
                  }}
                >
                  <strong>STAFF No.:- {itemValues.fileNumber}</strong>
                </td>
              </tr>
              <tr>
                <td align="left">
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                    style={{ fontSize: "12px", color: "#fff" }}
                  >
                    <tr>
                      <td width="42%">&nbsp;</td>
                      <td width="58%">
                        <strong>
                          Gender:-{" "}
                          <div className="text-uppercase d-inline">
                            {itemValues.sex}
                          </div>
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>
                        <strong>Job Shift:- {itemValues.shift}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>
                        <strong>Valid Till:- {itemValues.validity}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td style={styles.barcodeContainer}>
                        <BarCode
                          barcodeValuess={itemValues.fileNumber}
                          barcodeHeights="15"
                          barcodeWidths="1"
                          barcodeFontSizes="12"
                          displayValues="false"
                        />
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </>
  );
};
export default StaffIDCard;
